import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadDayStatFailed, loadDayStatSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadDayStat(action) {
  try {
    const {
      payload = {},
    } = action;
    const url = `${BACKEND_URL}/dashboard/load-day-stat`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK && data) {
      const res = Object.keys(data).map(key => ({ name: key, count: data[key] }));
      yield put(loadDayStatSuccessful(res));
      yield call(resolveActionPromise(action, res));
    } else {
      yield put(loadDayStatFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadDayStatFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
